export enum FileTreeNodeKind {
    File = 'file',
    Folder = 'folder'
}

export enum FileTreeMoveStatus {
    Allowed = 'allowed',
    Descendant = 'descendant',
    SameParent = 'same-parent',
    Self = 'self'
}

export enum FileTreeDropState {
    Idle = 'idle',
    Invalid = 'invalid',
    Valid = 'valid'
}

export enum FileTreeViewState {
    Empty = 'empty',
    Loading = 'loading',
    NoVersion = 'no-version'
}
